<template>
  <div class="container d-flex centered">
    <div class="col-12">
      <div class="d-flex centered fade-in-image">
        <img src="../assets/me.webp" alt="me" class="image" />
      </div>
      <div :data-aos="!loaded ? 'fade-right' : ''">
        <h1 class="text--green hi mt-4 text-center">Hi, my name is</h1>
        <h2 class="name text-center">Mohammad Karim</h2>
      </div>
      <div class="description" :data-aos="!loaded ? 'fade-up' : ''">
        <p>
          As a full-stack developer with over 3 years of experience, I bring a
          core expertise in developing robust web applications and
          cross-platform mobile solutions, underpinned by exceptional critical
          thinking skills that allow me to tackle any challenge with a proactive
          and solution-oriented mindset.
        </p>

        <!-- <h2 class="text-center">About Me</h2> -->
        <p>
          With a Bachelor's degree from UTS, my full-stack development journey
          continues at Mirk following an internship. I possess a proven ability
          to solve complex programming challenges, demonstrated through my work
          on various projects and as a sole trader at Quormotion. There, I
          independently developed applications like Brain Twist and delivered
          key client solutions, including a Bulk SMS Sender to streamline
          customer communication and an Invoice Processor for efficiency.
        </p>
      </div>

      <ContactLinks />

      <h2 class="col-md-12 col-12 text-center text--green my-4">What I do</h2>
      <SkillCards />

      <h2 data-aos="zoom-in" class="text-center text--green my-4">
        My Projects
      </h2>
      <div v-for="(project, index) in slicedProject" :key="index">
        <ProjectCard
          :title="project.title"
          :description="project.description"
          :links="project.links"
          :tech-stack="project.techStack"
          :image-source="project.imageSource"
          :show-image-right="project.showImageRight"
          :is-small-image="!!project.isSmallImage"
          :is-large-image="!!project.isLargeImage" />
      </div>
      <div data-aos="zoom-in" class="d-flex centered">
        <router-link to="/projects" class="view-more"> View More </router-link>
      </div>

      <h2 data-aos="zoom-in" class="text-center text--green my-4">
        My Experience
      </h2>
      <ExperienceList />
    </div>
  </div>
</template>

<script setup lang="ts">
import {onMounted, ref} from 'vue';

import ContactLinks from '@/components/about/ContactLinks.vue';
import SkillCards from '@/components/about/SkillCards.vue';
import ProjectCard from '@/components/project/ProjectCard.vue';
import ExperienceList from '@/components/experience/TimelineList.vue';

import {projects} from '@/data/projects';
import store from '@/store';

const loaded = ref(false);

const slicedProject = projects.slice(0, 4);

onMounted(() => {
  if (store.state.loadedScreens.includes('about')) {
    loaded.value = true;
  } else {
    store.commit('addLoadedScreen', 'about');
    loaded.value = false;
  }
});
</script>

<style lang="scss" scoped>
.image {
  height: 200px;
  width: 200px;
  border-radius: 50%;
  object-fit: cover;
}
.hi {
  font-size: 25px;
}
.name {
  font-size: 60px;
  line-height: 80px;
  color: #b1b1b1;
  margin-bottom: 20px;
}

.description {
  p {
    font-size: 20px;
    text-align: center;
  }
}

.view-more {
  font-size: 20px;
  color: #9a9999;
  text-decoration: underline;
  cursor: pointer;
}
</style>
